import React from "react";
import { Button, Divider, Icon, Stack, Text, useColorModeValue } from "@chakra-ui/react";
import { MdBuild, MdCached, MdDeleteSweep, MdStorage } from "react-icons/md";
import Card from "horizon/components/card/Card";

/**
 * Renders the main cache action buttons: migrate, cache, and clear.
 * @param {Object} props - Loading states and action callbacks for main operations
 * @returns {React.ReactElement}
 */
function CacheMainActions({ migrationLoading, cacheLoading, clearCacheLoading, onMigrate, onCacheCards, onClearCache }) {
    return (
        <>
            <Button w="100%" colorScheme="orange" leftIcon={<Icon as={MdBuild} />} onClick={onMigrate} isDisabled={migrationLoading}>
                Migrate DECLINED &rarr; EXPIRED
            </Button>
            <Button w="100%" colorScheme="brand" leftIcon={<Icon as={MdCached} />} onClick={onCacheCards} isLoading={cacheLoading}>
                Cache contact cards
            </Button>
            <Button w="100%" colorScheme="red" leftIcon={<Icon as={MdDeleteSweep} />} onClick={onClearCache} isLoading={clearCacheLoading}>
                Clear cache
            </Button>
        </>
    );
}

/**
 * Renders the stack of action buttons for cache and migration operations.
 * @param {Object} props - Loading states and action callbacks
 * @returns {React.ReactElement}
 */
function CacheActionButtons({ migrationLoading, cacheLoading, clearCacheLoading, statsLoading, onMigrate, onCacheCards, onClearCache, onRefreshStats }) {
    return (
        <Stack spacing="12px">
            <CacheMainActions migrationLoading={migrationLoading} cacheLoading={cacheLoading}
                clearCacheLoading={clearCacheLoading} onMigrate={onMigrate}
                onCacheCards={onCacheCards} onClearCache={onClearCache} />
            <Divider my="6px" />
            <Button w="100%" variant="outline" leftIcon={<Icon as={MdStorage} />} onClick={onRefreshStats} isLoading={statsLoading}>
                Refresh stats
            </Button>
        </Stack>
    );
}

/**
 * Left-side panel containing action buttons for database migration,
 * cache population, cache clearing, and stats refresh.
 * @param {object} props - Loading states and action callbacks (forwarded to CacheActionButtons)
 * @returns {React.ReactElement}
 */
function CacheActionsPanel(props) {
    const titleColor = useColorModeValue("secondaryGray.900", "white");
    return (
        <Card>
            <Text fontSize="lg" fontWeight="700" color={titleColor} mb="16px">Available actions</Text>
            <CacheActionButtons {...props} />
        </Card>
    );
}

export default CacheActionsPanel;
